import { makeObservable, observable, action } from 'mobx';
import { BaseStore } from './baseStore';
import { Store } from './store';

export enum LanguageStoreState {
  NOT_INITIALIZED = 1 << 0,
  LOADED = 1 << 1,
}

export class LanguageStore extends BaseStore<LanguageStoreState> {
  language: string;
  translations: Record<string, Record<string, string>>;

  constructor(store: Store) {
    super(LanguageStoreState.NOT_INITIALIZED, store, 'orange');
    makeObservable(this, {
      language: observable,
      setLanguage: action,
    });
    this.translations = {
      pl: {
        navbar_notifications: 'Powiadomienia',
        navbar_help: 'Pomoc',
        PROFILE_STATUS_ONLINE: 'Dostępny',
        PROFILE_STATUS_AWAY: 'Zaraz wracam',
        PROFILE_STATUS_BUSY: 'Zajęty',
        PROFILE_STATUS_DND: 'Nie przeszkadzać',
        PROFILE_STATUS_OFFLINE: 'Nieaktywny',
        PROFILE_STATUS_INVISIBLE: 'Niewidoczny',
        PROFILE_INFO_ABOUT_ME: 'O mnie',
        PROFILE_INFO_ACCOUNT_SINCE: 'Konto od',
        PROFILE_INFO_LINKED_ACCOUNTS: 'Podłączone konta',
        PROFILE_ABOUT_ME_DEFAULT_1: 'Jestem nowy, zacznijmy czatować na Chatty!',
        PROFILE_ABOUT_ME_DEFAULT_2: 'Gotowy na nowe znajomości!',
        PROFILE_ABOUT_ME_DEFAULT_3: 'Powiedz cześć i połączmy się!',
        PROFILE_EDIT_PROFILE_BTN: 'Edytuj profil',
        PROFILE_EDIT_PROFILE_SAVE: 'Zapisz zmiany',
        PROFILE_EDIT_PROFILE_CANCEL: 'Anuluj',
        PROFILE_EDIT_PROFILE_NOT_SAVED_CHANGES: 'Masz niezapisane zmiany! Co chcesz zrobić?',
        BADGE_ACQUIRED: 'Otrzymano {{date}}',
        BADGE_VERIFIED: 'Zweryfikowany',
        BADGE_STAFF: 'Pracownik',
        BADGE_PARTNER: 'Partner',
        BADGE_DEVELOPER: 'Deweloper',
        BADGE_EARLY: 'Złoty uzytkownik',
        SIDEBAR_HOME: 'Strona główna',
        SIDEBAR_DEVELOPER: 'Deweloper',
        SIDEBAR_THEME: 'Motyw',
        SIDEBAR_CONSOLE: 'Konsola',
      },
      en: {
        navbar_notifications: 'Notifications',
        navbar_help: 'Help',
        PROFILE_STATUS_ONLINE: 'Online',
        PROFILE_STATUS_AWAY: 'Away',
        PROFILE_STATUS_BUSY: 'Busy',
        PROFILE_STATUS_DND: 'Do Not Disturb',
        PROFILE_STATUS_OFFLINE: 'Offline',
        PROFILE_STATUS_INVISIBLE: 'Invisible',
        PROFILE_INFO_ABOUT_ME: 'About Me',
        PROFILE_INFO_ACCOUNT_SINCE: 'Account Since',
        PROFILE_INFO_LINKED_ACCOUNTS: 'Linked Accounts',
        PROFILE_ABOUT_ME_DEFAULT_1: "I'm new, let's start chatting on Chatty!",
        PROFILE_ABOUT_ME_DEFAULT_2: 'Ready to make new friends!',
        PROFILE_ABOUT_ME_DEFAULT_3: "Say hi and let's connect!",
        PROFILE_EDIT_PROFILE_BTN: 'Edit Profile',
        PROFILE_EDIT_PROFILE_SAVE: 'Save Changes',
        PROFILE_EDIT_PROFILE_CANCEL: 'Cancel',
        PROFILE_EDIT_PROFILE_NOT_SAVED_CHANGES: 'You have unsaved changes! What do you want to do?',
        BADGE_ACQUIRED: 'Acquired on {{date}}',
        BADGE_VERIFIED: 'Verified',
        BADGE_STAFF: 'Employee',
        BADGE_PARTNER: 'Partner',
        BADGE_DEVELOPER: 'Developer',
        BADGE_EARLY: 'The golden member',
        SIDEBAR_HOME: 'Home',
        SIDEBAR_DEVELOPER: 'Developer',
        SIDEBAR_THEME: 'Theme',
        SIDEBAR_CONSOLE: 'Console',
      },
    };
    const browserLang = navigator.language?.slice(0, 2) || 'pl';
    const saved = localStorage.getItem('language');
    const initialLang = saved || (browserLang in this.translations ? browserLang : 'pl');
    this.setLanguage(initialLang);
  }

  setLanguage(lang: string) {
    this.language = lang;
    localStorage.setItem('language', lang);
    this.setState(LanguageStoreState.LOADED);
    this.log('Langugage is setted');
  }

  t(key: string, params?: Record<string, string>) {
    this.log('Trying translation ' + key);
    let translation = this.translations[this.language]?.[key] || key;
    if (params) {
      for (const [param, value] of Object.entries(params)) {
        translation = translation.replace(`{{${param}}}`, value);
      }
    }
    return translation;
  }

  isReady(): boolean {
    return this.hasState(LanguageStoreState.LOADED);
  }

  reload(): void {
    const saved = localStorage.getItem('language');
    if (saved) this.setLanguage(saved);
  }

  logout(): void {
    this.language = 'pl';
    this.setState(LanguageStoreState.NOT_INITIALIZED);
  }
}
